"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var isNull_1 = __importDefault(require("lodash/isNull"));
var CvButton = function (props) {
    var dataAtrributes = Object.entries(props.linkOptions.data).reduce(function (memo, _a) {
        var key = _a[0], value = _a[1];
        memo["data-".concat(key)] = value;
        return memo;
    }, {});
    return (react_1.default.createElement("a", __assign({ href: props.linkPath, className: (0, classnames_1.default)('coUiCvButton-Container', props.customContainerClass), target: props.linkOptions.target, rel: props.linkOptions.rel }, dataAtrributes),
        react_1.default.createElement("div", { className: "coUiCvButton-InnerBox" },
            react_1.default.createElement("span", { className: (0, classnames_1.default)('coUiCvButton-Label', props.customClasses.label) }, props.label),
            !(0, isNull_1.default)(props.subLabel) &&
                react_1.default.createElement("span", { className: (0, classnames_1.default)('coUiCvButton-SubLabel', props.customClasses.subLabel) }, props.subLabel))));
};
exports.default = CvButton;
